import { UserPermissionHeader } from 'components/user/user-permission-header/user-permission-header'
import { useState } from 'react'
import { Avatar } from 'components/avatar/avatar'
import { useTranslate } from 'utils'
import { CrownOutlined, RightOutlined } from '@ant-design/icons'
import { useResources } from 'api'
import { VerticalContainer } from 'components/styled'
import { Search } from 'components/search/search'
import { theme } from 'antd'
import { VerticalPaginatedList } from 'components/vertical-paginated-list/vertical-paginated-list'

type Props = {
    onSelect: (id: string | null) => void
    onBack: () => void
}

export const UserPermissionResourceSelect = ({ onSelect, onBack }: Props) => {

    //hooks:
    const { __ } = useTranslate()
    const { token: { fontSizeSM, fontSizeLG, margin, paddingXS, paddingLG } } = theme.useToken()
    const [ search, setSearch ] = useState<string | null>(null)
    
    //resources:
    const {
        data: resources,
        pageNum,
        totalPages,
        isLoading,
        isPreviousData,
        isNextDisabled,
        isPreviousDisabled,
        fetchNext,
        fetchPrevious
    } = useResources(null, null, null, [], search)

    return (
        <VerticalContainer style={{ height: '100%', paddingBottom: paddingXS, gap: margin }}>

            <VerticalContainer>

                {/* header */}
                <UserPermissionHeader
                    title={__`resource`}
                    onBack={onBack}
                >
                    <Search
                        placeholder={__`search_resources`}
                        onSearch={setSearch}
                    />
                </UserPermissionHeader>

            </VerticalContainer>

            <VerticalPaginatedList
                isFirstLoading={isLoading}
                isForbidden={resources === null}
                isError={resources === false}
                notFound={(resources && resources.length === 0) ?? false}
                pageNum={pageNum}
                totalPages={totalPages}
                isPreviousData={isPreviousData}
                isNextDisabled={isNextDisabled}
                isPreviousDisabled={isPreviousDisabled}
                scrollable={true}
                fetchNext={fetchNext}
                fetchPrevious={fetchPrevious}
            >

                <Avatar
                    name={__`all`}
                    image={null}
                    placeholder={<CrownOutlined style={{ fontSize: fontSizeLG }}/>}
                    backgroundColor='transparent'
                    description={__`access_to_all_resources`}
                    extraIcon={<RightOutlined style={{ fontSize: fontSizeSM }}/>}
                    style={{ width: '100%', paddingLeft: paddingLG, paddingRight: paddingLG, borderRadius: 0 }}
                    onClick={() => onSelect(null)}
                />

                {resources && resources.map(resource =>
                    <Avatar
                        key={resource.id}
                        name={resource.name}
                        image={resource.image.path}
                        description={resource.email}
                        extraIcon={<RightOutlined style={{ fontSize: fontSizeSM }}/>}
                        style={{ width: '100%', paddingLeft: paddingLG, paddingRight: paddingLG, borderRadius: 0 }}
                        onClick={() => onSelect(resource.id)}
                    />
                )}

            </VerticalPaginatedList>

        </VerticalContainer>
    )

}
